import _ from "lodash";
import React, { type ErrorInfo } from "react";

import ErrorLoggerService from "./core/ErrorLoggerService";

type ComponentPropTypes = {
  children: React.ReactNode;
}

class ErrorBoundary extends React.Component<ComponentPropTypes> {

  static getDerivedStateFromError(error: any) {
    return { hasUiCrashed: error };
  }

  state = { hasUiCrashed: false };

  componentDidCatch(err: Error, info: ErrorInfo) {
    ErrorLoggerService("App.ErrorBoundary", "componentDidCatch err ", err);
    ErrorLoggerService("App.ErrorBoundary", "componentDidCatch info ", info);
  }

  render() {
    const { hasUiCrashed } = this.state;
    if (hasUiCrashed) {
      return (
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: 20
        }}>
          <br />
          <h1>&iexcl;Vaya!</h1>
          <h5>Algo sali&oacute; mal.<br /><br />Vuelva a cargar la p&aacute;gina e int&eacute;ntelo de nuevo.</h5>
          <br />
          <button
            style={{
              background: "none",
              backgroundColor: "transparent",
              border: "solid 1px transparent",
              borderColor: "#4251CD",
              borderRadius: 28,
              boxShadow: "none",
              color: "#4251CD",
              cursor: "pointer",
              fontSize: 18,
              fontStyle: "normal",
              height: 55,
              lineHeight: 35,
              margin: 0,
              outline: 0,
              padding: "10px 20px",
              textAlign: "center",
              display: "flex",
              textShadow: "none",
              alignItems: "center",
              justifyContent: "center"
            }}
            onClick={() => window.location.reload()}
            type="button">
            Int&eacute;ntelo de nuevo
          </button>
          <br />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
